import { useAppSelector } from 'shared/hooks'

import { selectHasInvited } from '../util/selector'
export const useHasInvited = () => useAppSelector(selectHasInvited)
